import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// import JS files

// import others files
import Template from "../../shares/Template";
import Header from "../../shares/Header";
import MuiButton from "../../mui/MuiButton";
import useFetch from "../../../context/useFetch";
import ListCard from "../ListCard";
import ConfirmModal from "../modals/ConfirmModal";
import RejectModal from "../modals/RejectModal";
import SubsModal from "../modals/SubsModal";
import PicsModal from "../modals/PicsModal";
import { useUserData } from "../../../context/UserDataContext";
import ReturnModal from "../modals/ReturnModal";
import MuiPagination from "../../mui/MuiPagination";
import EmptyList from "../../shares/EmptyList";

const ConfirmedList = (props) => {
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 10,
    count: 0,
  });
  const [apiData, setApiData] = useState([]);

  const { userData } = useUserData();
  const [selectedItem, setSelectedItem] = useState();

  const [apiDataNum, setApiDataNum] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const GetTreatmentRequestNum = useFetch({
    url:
      userData.job == "TreatmentAdmin" || userData.job == "Admin"
        ? `User_Service/${userData.username}/admin_get_treatment_request_num`
        : userData.job == "TreatmentProvinceExpert"
        ? `User_Service/${userData.username}/province_expert_get_treatment_request_num`
        : userData.job == "TreatmentCityExpert"
        ? `User_Service/${userData.username}/city_expert_get_treatment_request_num`
        : `User_Service/${userData.username}/area_expert_get_treatment_request_num`,
    method: "GET",
    params: { status: "accept" },
    trigger: true,

    argFunc: (res) => {
      setApiDataNum(res.data);
    },
  });

  const GetTreatmentRequest = useFetch({
    url:
      userData.job == "TreatmentAdmin" || userData.job == "Admin"
        ? `User_Service/${userData.username}/admin_get_treatment_request`
        : userData.job == "TreatmentProvinceExpert"
        ? `User_Service/${userData.username}/province_expert_get_treatment_request`
        : userData.job == "TreatmentCityExpert"
        ? `User_Service/${userData.username}/city_expert_get_treatment_request`
        : `User_Service/${userData.username}/area_expert_get_treatment_request`,
    method: "GET",
    params: { status: "accept" },
    trigger: true,
    pagination: paginationPageInfo,

    argFunc: (res) => {
      setApiData(res.results);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
  });
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    GetTreatmentRequest.reFetch();
  };
  const returnPageTreatmentRequest = useFetch({
    url: `TreatmentRequest_Service/page_return_treatment_request`,
    method: "POST",
    trigger: false,
    data: { status: "accept", ids: selectedOptions },
    argFunc: (res) => {
      setConfirmModal(false);
      GetTreatmentRequest.reFetch();
    },
  });

  const returnTreatmentRequest = useFetch({
    url: `TreatmentRequest_Service/${selectedItem?.id}/return_treatment_request`,
    method: "POST",
    trigger: false,
    data: { status: "pending" },
    argFunc: (res) => {
      setConfirmModal(false);
      setReturnModal(false);
      GetTreatmentRequest.reFetch();
    },
  });

  const [confrimModal, setConfirmModal] = useState(false);
  const handleConfirmModal = () => {
    setConfirmModal((before) => !before);
  };

  const [returnModal, setReturnModal] = useState(false);
  const handleReturnModal = (userSelectedItem) => {
    setSelectedItem(userSelectedItem);
    setReturnModal((before) => !before);
  };

  const [rejectModal, setRejectModal] = useState(false);
  const handleRejectModal = (userSelectedItem) => {
    setSelectedItem(userSelectedItem);

    setRejectModal((before) => !before);
  };

  const [subsModal, setSubsModal] = useState(false);
  const handleSubsModal = (userSelectedItem) => {
    setSelectedItem(userSelectedItem);

    setSubsModal((before) => !before);
  };

  const [picsModal, setPicsModal] = useState(false);
  const handlePicsModal = (userSelectedItem) => {
    setSelectedItem(userSelectedItem);

    setPicsModal((before) => !before);
  };
  const page_update_options = () => {
    setSelectedOptions(apiData.map((it) => it.id));
  };

  const update_options = (ID) => {
    let options = [...selectedOptions];

    if (selectedOptions.filter((it) => it == ID).length > 0) {
      let op_index = selectedOptions.findIndex((it) => it == ID);
      options.splice(op_index, 1);
      setSelectedOptions(options);
    } else {
      setSelectedOptions([
        ...selectedOptions,
        apiData.filter((it) => it.id == ID)[0].id,
      ]);
    }
  };
  console.log("selectedOptions", selectedOptions);
  const getExcel = useFetch({
    url: `User_Service/${userData.username}/get_excel`,
    method: "POST",
    trigger: false,
    data: {
      status: "accept",
    },
    blobType: true,
    // setter: setLessonInfo,
    argFunc: (res) => {
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      // link.setAttribute("download", "file.xlsx");
      link.setAttribute("download", `${Date.now()}.xlsx`);

      document.body.appendChild(link);
      link.click();
    },
  });

  const download_excel = () => {
    getExcel.reFetch();
  };
  const getCodingExcel = useFetch({
    url: `User_Service/${userData.username}/get_excel_by_coding`,
    method: "POST",
    trigger: false,
    data: {
      status: "accept",
    },
    blobType: true,
    // setter: setLessonInfo,
    argFunc: (res) => {
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      // link.setAttribute("download", "file.xlsx");
      link.setAttribute("download", `${Date.now()}.xlsx`);

      document.body.appendChild(link);
      link.click();
    },
  });

  const download_coding_excel = () => {
    getCodingExcel.reFetch();
  };
  return (
    <>
      {confrimModal && (
        <ConfirmModal
          openModal={confrimModal}
          setOpenModal={setConfirmModal}
          width="md:w-1/3"
        />
      )}

      {returnModal && (
        <ReturnModal
          apiCall={returnTreatmentRequest}
          data={selectedItem}
          openModal={returnModal}
          setOpenModal={setReturnModal}
          width="md:w-1/3"
        />
      )}

      {rejectModal && (
        <RejectModal
          openModal={rejectModal}
          setOpenModal={setRejectModal}
          width="md:w-1/3"
        />
      )}
      {subsModal && (
        <SubsModal
          data={selectedItem}
          openModal={subsModal}
          setOpenModal={setSubsModal}
          width="md:w-3/4"
          isOverflow
        />
      )}
      {picsModal && (
        <PicsModal
          data={selectedItem}
          openModal={picsModal}
          setOpenModal={setPicsModal}
          width="md:w-3/4"
          isOverflow
        />
      )}
      <Template sidebarActiveLink="confirmed-list">
        <Header header="بیمه‌شده‌های تایید‌شده" />
        {apiData.length <= 0 ? (
          <div className="h-72 flex flex-col justify-center">
            <EmptyList text="موردی ثبت نشده‌است." icon={ErrorOutlineIcon} />
          </div>
        ) : (
          <>
            <div className="flex justify-between items-center mt-8 bg-[#f8f8f8] p-2 rounded-lg">
              <span className="font-bold text-myblack-100">
                تعداد کل: <span className="">{apiDataNum}</span>
              </span>
              <div className="flex gap-2">
                <MuiButton
                  disabled={getExcel.loading}
                  onClick={() => download_excel()}
                  variant="outlined"
                  icon={<DownloadIcon />}
                  color="primary"
                  text="دانلود اکسل"
                />
                <MuiButton
                  disabled={getExcel.loading}
                  onClick={() => download_coding_excel()}
                  variant="outlined"
                  icon={<DownloadIcon />}
                  color="primary"
                  text="دانلود اکسل با کدینگ"
                />
              </div>
            </div>
            <div className="flex justify-between items-center mt-8 mb-4">
              <span className="font-bold text-myblack-100">
                بیمه‌شده‌های اصلی:
              </span>
              <div className="flex items-center">
                <div className="ml-2">
                  <MuiButton
                    onClick={() => page_update_options()}
                    variant="outlined"
                    icon={<CheckBoxOutlineBlankIcon />}
                    color="primary"
                    text="انتخاب موارد این صفحه"
                  />
                </div>
                <div className="">
                  <MuiButton
                    onClick={() => returnPageTreatmentRequest.reFetch()}
                    variant="outlined"
                    icon={<ArrowForwardIcon />}
                    color="secondary"
                    text="برگشت گروهی"
                  />
                </div>
              </div>
            </div>

            {apiData.map((it, ind) => {
              return [
                <ListCard
                  update_options={update_options}
                  selectedOptions={selectedOptions}
                  data={it}
                  setSelectedItem={setSelectedItem}
                  confirmFunc={handleConfirmModal}
                  rejectFunc={handleRejectModal}
                  returnFunc={handleReturnModal}
                  showSubsFunc={handleSubsModal}
                  showPicsFunc={handlePicsModal}
                  status="confirmed"
                />,
              ];
            })}
            <div className="mt-4 flex justify-center">
              <MuiPagination
                onChange={onChangePage}
                count={Math.ceil(
                  paginationPageInfo.count / paginationPageInfo.pageSize
                )}
              />
            </div>
          </>
        )}
      </Template>
    </>
  );
};

export default ConfirmedList;
